import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Button } from "rbx";

import {
  CustomerSelect,
  SystemCodeSelect,
  BooleanInput,
  PaymentTermSelect
} from "../../../../components/inputs";

import { formatCurrency } from "../../../../utils";

import { TariffDisplay } from "../../../../components/Tariffs";

import HorizontalRule from "../../../../styles/HorizontalRule";

import {
  OrderDetails,
  DeliveryDate,
  OutsideRouteDateRangeDisplay
} from "../components";

const ResetStatusButton = ({ order, onClick }) =>
  // if order is non-bill and has been cancelled or status is exported to accounting
  ((order?.Status?.CodeId === "NB" && order?.Cancel) ||
    order?.Status?.CodeId === "EXA") && (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%"
      }}
    >
      <Field>
        <Control>
          <Button
            color="primary"
            size="small"
            style={{ margin: "10px 0" }}
            onClick={onClick}
          >
            <span>Reset Status</span>
          </Button>
        </Control>
      </Field>
    </div>
  );

ResetStatusButton.propTypes = {
  order: PropTypes.object,
  onClick: PropTypes.func
};
function Billing({ order, adding = false, editing, onChange, resetStatus }) {
  return (
    <React.Fragment>
      <ResetStatusButton order={order} onClick={resetStatus} />
      <div className="row first-row-billing">
        <Control>
          <CustomerSelect
            showHelp
            icon="globe"
            label="Bill To"
            name="BillToRecIdRef"
            readOnly={!editing}
            value={order.BillToRecIdRef}
            variables={{
              where: { Active: true, BillToCust: true },
              orderByMulti: ["CustomerNo_ASC"]
            }}
            onChange={onChange}
          />
        </Control>
        <Control>
          <Label>Contract</Label>
          <Input
            readOnly
            autocomplete="new"
            name="Contract"
            value={order?.Route?.Contract}
            onChange={onChange}
          />
        </Control>
        <div className="order-detail-tab-container charges">
          <Label>Charge For:</Label>
          <Field>
            <Control>
              <Label>Saturday</Label>
              <BooleanInput
                name="ChargeForSaturday"
                readOnly={!editing}
                value={order.ChargeForSaturday}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Sunday</Label>
              <BooleanInput
                name="ChargeForSunday"
                readOnly={!editing}
                value={order.ChargeForSunday}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Holiday</Label>
              <BooleanInput
                name="ChargeForHoliday"
                readOnly={!editing}
                value={order.ChargeForHoliday}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Non-Bill</Label>
              <BooleanInput
                name="NonBill"
                readOnly={!editing}
                value={order.NonBill}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Tolls</Label>
              <BooleanInput readOnly name="Tolls" value={order.Route?.Tolls} />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Charge For Tolls</Label>
              <Input
                readOnly
                name="ChargeForTolls"
                type="text"
                value={formatCurrency(order.Route?.ChargeForTolls)}
              />
            </Control>
          </Field>
        </div>
      </div>
      <div className="row second-row-billing">
        <Control>
          <PaymentTermSelect
            showLabel
            disabled={!editing}
            label="Payment Term"
            name="PaymentTermsRecIdRef"
            value={order?.PaymentTermsRecIdRef}
            where={{ Active: true }}
            onChange={onChange}
          />
        </Control>
        <Control>
          <SystemCodeSelect
            icon="spinner"
            label="Payment Method"
            lookup={{ Category: "Route", Code: "PaymentMethod" }}
            name="PaymentMethodRecIdRef"
            readOnly={!editing}
            value={order.PaymentMethodRecIdRef}
            onChange={onChange}
          />
        </Control>
        <Control>
          <SystemCodeSelect
            icon="spinner"
            label="Load Type"
            lookup={{ Category: "Route", Code: "LoadType" }}
            name="LoadTypeRecIdRef"
            readOnly={!editing}
            value={order.LoadTypeRecIdRef}
            onChange={onChange}
          />
        </Control>
        <Control>
          <Label>Net Weight</Label>
          <Input
            readOnly
            name="NetWeight"
            type="text"
            value={order.NetWeight}
          />
        </Control>
        <Control>
          <OutsideRouteDateRangeDisplay
            dateFormat="MM/DD/YYYY"
            displayDate={order.Route?.StartDate}
            label="Route Start Date"
            name="StartDate"
            routeRecId={order.RouteRecIdRef}
            tariffRecId={order.Route?.TariffRecIdRef}
            value={order.ScheduledDeliveryDate}
          />
        </Control>
        <Control>
          <OutsideRouteDateRangeDisplay
            dateFormat="MM/DD/YYYY"
            displayDate={order.Route?.EndDate}
            label="Route End Date"
            name="EndDate"
            routeRecId={order.RouteRecIdRef}
            tariffRecId={order.Route?.TariffRecIdRef}
            value={order.ScheduledDeliveryDate}
          />
        </Control>
        <DeliveryDate
          name="ScheduledDeliveryDate"
          routeRecId={order.RouteRecIdRef}
          tariffRecId={order.Route?.TariffRecIdRef}
          value={order.ScheduledDeliveryDate}
        />
        <Control>
          <Label>Billing Notes</Label>
          <Input
            disabled={!editing}
            name="BillingNotes"
            type="text"
            value={order.BillingNotes}
            onChange={onChange}
          />
        </Control>
      </div>
      <HorizontalRule />

      {!adding && (
        <React.Fragment>
          <TariffDisplay
            deliveryDate={order.ScheduledDeliveryDate}
            endDate={order.Route.EndDate}
            readOnly={!editing}
            routeRecIdRef={order.RouteRecIdRef}
            tariffRecIdRef={order.TariffRecIdRef}
            onChange={onChange}
          />
        </React.Fragment>
      )}
      {!adding && (
        <React.Fragment>
          <HorizontalRule />
          <OrderDetails
            billable={!order.NonBill}
            orderRecId={order.RecId}
            statusRecId={order.StatusRecIdRef}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

Billing.propTypes = {
  onChange: PropTypes.func,
  order: PropTypes.object,
  editing: PropTypes.bool,
  adding: PropTypes.bool,
  resetStatus: PropTypes.func
};
Billing.defaultProps = {
  order: {}
};
export default Billing;
